import { render, staticRenderFns } from "./NormalSearchNav180.vue?vue&type=template&id=0be2b241&scoped=true"
import script from "./NormalSearchNav180.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav180.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be2b241",
  null
  
)

export default component.exports